const ROOT = "giphyPlayer";
const UPLOAD_MODAL = "giphyUploadModal";
const UPLOAD_MODAL_INPUT = "giphyUploadModalInput";
const GIPHY_ITEM = "giphyItem";
export {
  GIPHY_ITEM,
  ROOT,
  UPLOAD_MODAL,
  UPLOAD_MODAL_INPUT
};
//# sourceMappingURL=dataHooks.js.map
